import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  IconButton,
  Tooltip
} from '@mui/material';
import { ContentCopy } from '@mui/icons-material';
import { getEnvId } from '../../redux/selectors';
import config from '../../cfg';

const { api_url } = config;

const Webhook = ({ entity, flowId,tenantId }) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [webhookUrl, setWebhookUrl] = useState();

  useEffect(() => {
    setWebhookUrl(`${api_url}/webhook/${entity?.tap || entity?.id}/${getEnvId()}/${flowId}?tenant_id=${tenantId}`);
  }, [entity, flowId, tenantId]);

  const handleCopyWebhook = () => {
    navigator.clipboard.writeText(webhookUrl);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <Box sx={{ maxWidth: '800px', margin: '0 auto', width: '100%' }}>
      <Box mt={3}>
        <Typography variant="subtitle1" fontWeight={500} sx={{ fontSize: '1rem', mb: 1 }}>
          Add webhook URL in {entity?.label}
        </Typography>
        <Typography variant="body2" color="text.lightish" sx={{ mb: 2 }}>
          We listen to events from {entity?.label} using webhooks. Save the webhook URL below in {entity?.label} to capture events.
        </Typography>
        
        <Box mt={2}>
          <TextField
            fullWidth
            variant="outlined"
            size="normal"
            value={webhookUrl}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <Tooltip title={copySuccess ? "Copied!" : "Copy to clipboard"}>
                    <IconButton onClick={handleCopyWebhook} edge="end" size="small">
                      <ContentCopy fontSize="small" sx={{ fontSize: '14px' }} />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
              sx: { 
                bgcolor: 'grey.50',
                fontSize: '0.85rem',
                '& input': {
                  py: 1
                }
              }
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default Webhook; 